import React, { useEffect, useReducer } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import CustomFields from './CustomFields';

export default function CustomFieldWrapper({
  getCustomFieldTemplate,
  getCustomData,
  entityId,
  sliceName,
  customFields,
  setCustomFields,
  errors,
  selectedDivisions,
  isDisplay = false,
  value,
  onChange,
}) {
  const dispatch = useDispatch();
  const [shouldUpdate, forceUpdate] = useReducer((x) => x + 1, 0);
  const customData = useSelector((state) => state[sliceName]?.customData);
  const customDataFiles = useSelector((state) => state[sliceName]?.customDataFiles);
  const customFieldTemplate = useSelector((state) => state[sliceName]?.customFieldTemplate);

  useEffect(() => {
    dispatch(getCustomFieldTemplate());
    dispatch(getCustomData(entityId));
  }, [entityId]);

  useEffect(() => {
    setCustomFields?.(customFieldTemplate?.sections);
  }, [customFieldTemplate]);

  useEffect(() => {
    forceUpdate();
  }, [customData]);

  if (!customFields?.length) return null;

  return (
    <CustomFields
      key={`${entityId}${shouldUpdate}`} // Need to force re-render
      initialValues={customData}
      customFields={customFields}
      divisions={selectedDivisions}
      errors={errors}
      fileMap={customDataFiles}
      isDisplay={isDisplay}
      value={value}
      onChange={onChange}
    />
  );
}

CustomFieldWrapper.propTypes = {
  getCustomFieldTemplate: PropTypes.func.isRequired,
  getCustomData: PropTypes.func.isRequired,
  entityId: PropTypes.string.isRequired,
  sliceName: PropTypes.string.isRequired,
  customFields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setCustomFields: PropTypes.func,
  errors: PropTypes.shape(PropTypes.shape({})).isRequired,
  selectedDivisions: PropTypes.arrayOf(PropTypes.string).isRequired,
  isDisplay: PropTypes.bool,
  value: PropTypes.shape({}),
  onChange: PropTypes.func.isRequired,
};
CustomFieldWrapper.defaultProps = {
  isDisplay: false,
  setCustomFields: undefined,
};
